import React, {Component} from 'react';

import {Form, Field} from 'react-final-form'
import LoadingBar from "../../components/Modules/LoadingBar";


import PropTypes from 'prop-types';

class ECFForwarding extends Component {
  static propTypes = {
    permissions:    PropTypes.object.isRequired,
    loading:        PropTypes.bool,
    onSaveSettings: PropTypes.func.isRequired,
    settings:       PropTypes.object,
  }


  static getDerivedStateFromProps(nextProps, prevState) {
    console.debug("getDerivedStateFromProps", nextProps, prevState);
    return  {
      settingsDraft: nextProps.settings && ECFForwarding.settingsToForm(nextProps.settings)
    };
  }

  // Convert bakcend settings struct to something that can be manipulated by UI for a better UX
  static settingsToForm = settings => ({
    override_settings: ! settings.is_global,
    forwarding_option: settings.enabled
                          ? settings.fwd_all_case_emails
                            ? 'all'
                            : 'pleadings'
                          : '',
    destinations:       settings.destinations && settings.destinations.join("\n"),
    combine_pdf_option: settings.link_to_combined_pdf ? 'combine' : '',
    should_attach_pdf:  settings.attach_pdf           ? 'yes'     : '',
  });

  // Create settings object that backend understands
  static formToSettings = values => ({
    is_global:    ! values.override_settings,
    enabled:      !! values.forwarding_option,
    destinations: values.destinations,
    fwd_all_case_emails:  values.forwarding_option === 'all',
    link_to_combined_pdf: values.combine_pdf_option === 'combine',
    attach_pdf:           values.should_attach_pdf === 'yes',
  });


  onSave(values) {
    const settings = ECFForwarding.formToSettings(values);

    this.props.onSaveSettings(settings)
  }

  render() {
    if (this.props.loading) return <LoadingBar/>;

    return <Form
      onSubmit={ this.onSave.bind(this) }
      initialValues={ this.state.settingsDraft }
      render={({handleSubmit, submitting, pristine, values, form}) => (
        <form onSubmit={handleSubmit} style={ {marginBottom: '12px'} }>
          <div class="form-item">
            <label >
              <Field id="override_settings" name="override_settings" component="input" type="checkbox" className="form-checkbox" />
              &nbsp; Override Forwarding settings for this CaseFolder
            </label>

          </div>

          <div /* Fields appear faded unless the box above is ticked */
               style={{opacity: values.override_settings ? 1 : 0.50}}
               /* when any of the fields receive focus, we assume user wants to override the settings */
               onFocus={ () => form.change('override_settings', true) }>

            <div class="form-item">
              <label>Forward ECF emails for this case</label>
              <Field name="forwarding_option" component="select" className="form-select">
                <option value=""         >No</option>
                <option value="pleadings">Only Pleadings</option>
                <option value="all"      >Forward All</option>
              </Field>
            </div>


            <div
              /* forwarding tweaks only shown when options are visible  */
              style={ {display: values.forwarding_option ? 'block': 'none'} }>

              <div class="form-item">
                <label>Forward ECF emails on this case to the following distribution list:</label>
                <Field name="destinations" component="textarea" rows="4" cols="55" className="form-textarea"
                       placeholder="Add up to 10 emails, one per line or separated by commas or semicolons"/>
              </div>


              <div class="form-item">
                <label>Multiple PDF Handling</label>
                <Field name="combine_pdf_option" component="select" className="form-select">
                  <option value="combine">Combine PDFs</option>
                  <option value="">Leave PDFs Separate</option>
                </Field>
              </div>

              { this.props.permissions.can_attach_pdf &&
              <div class="form-item">
                <label>Attach PDFs</label>
                <Field name="should_attach_pdf" component="select" className="form-select">
                  <option value="">No</option>
                  <option value="yes">Yes</option>
                </Field>
              </div> }

            </div>

          </div>

          <button type="submit" disabled={ pristine } className={pristine || 'form-submit'} >Save</button>
          &nbsp;
          <a style={ pristine ? { cursor: 'default', color: 'gray' } : {cursor: 'pointer', color: 'blue'}} onClick={() => form.reset()}>Reset</a>

        </form>
      )
      }
    />


  }

}


export default ECFForwarding;



/** WEBPACK FOOTER **
 ** ./src/CaseFolder/Settings/ECFForwarding.jsx
 **/